import React from 'react';
import { Search, PenTool, Rocket, LifeBuoy } from 'lucide-react';
import Ornament from './Ornament';
import { useI18n } from '../context/I18nContext';

export default function Process() {
  const { tr } = useI18n();
  
  const steps = [
    {
      n: '01',
      icon: Search,
      title: tr('process.step1_title', 'Keşif & Analiz'),
      text: tr('process.step1_desc', 'Mevcut altyapınızı inceleriz, hedef oyuncu profili ve rakip analiziyle stratejik yol haritası çıkarırız.'),
    },
    {
      n: '02',
      icon: PenTool,
      title: tr('process.step2_title', 'Tasarım & Kodlama'),
      text: tr('process.step2_desc', 'C++, Python ve MySQL tabanlı modüler sistemler, özel 3D modeller ve UI kitleri ile üretim.'),
    },
    {
      n: '03',
      icon: Rocket,
      title: tr('process.step3_title', 'Kurulum & Lansman'),
      text: tr('process.step3_desc', 'Sunucunuza sorunsuz entegrasyon, yük testleri ve güvenliği doğrulanmış lansman.'),
    },
    {
      n: '04',
      icon: LifeBuoy,
      title: tr('process.step4_title', 'Destek & Optimizasyon'),
      text: tr('process.step4_desc', 'Discord/WhatsApp üzerinden 7/24 destek, sürekli güncellemeler ve performans ayarı.'),
    },
  ];

  return (
    <section className="relative py-20 lg:py-28 bg-[#0a0a0e]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <Ornament className="mb-6" />
          <div className="text-xs font-bold tracking-[0.32em] text-[#e4b44e]/85 mb-3">{tr('process.eyebrow', 'SÜRECİMİZ')}</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black text-white leading-[1.05]">
            <span dangerouslySetInnerHTML={{ __html: tr('process.title1', 'Sanattan <span class="gold-text">Savaş Alanına</span>') }} />
          </h2>
          <p className="text-white/60 mt-4 text-lg">{tr('process.subtitle', 'Fikirden efsaneye giden yolda 4 zarif adım.')}</p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block absolute top-14 left-[12%] right-[12%] h-[1px] bg-gradient-to-r from-transparent via-[#e4b44e]/40 to-transparent" />
          {steps.map((s, i) => (
            <div key={s.n} className="relative text-center group">
              <div className="relative mx-auto w-24 h-24 mb-6">
                <div className="absolute inset-0 rounded-full bg-gradient-to-b from-[#e4b44e]/20 to-transparent blur-xl group-hover:from-[#e4b44e]/35 transition" />
                <div className="relative w-24 h-24 rounded-full bg-[#0f0e12] border border-[#e4b44e]/40 flex items-center justify-center group-hover:border-[#f4d896] transition">
                  <s.icon className="w-9 h-9 text-[#f4d896]" strokeWidth={1.8} />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#e4b44e] text-[#17140b] font-display font-black text-xs flex items-center justify-center shadow-lg">
                  {s.n}
                </div>
              </div>
              <h3 className="font-display text-xl font-bold text-white mb-2">{s.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed max-w-xs mx-auto">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
